import * as comparison from '../actions/comparison.actions';
import { reorderArray } from 'ionic-angular';

export interface State {
  isFetching: boolean;
  chart: string;
  companies: any;
  ticker: string;
}

export const initialState: State = {
  chart: 'ebitMargin',
  isFetching: false,
  companies: [],
  ticker: ''
}

export function reducer(state = initialState, action: comparison.Actions): State {
  switch (action.type) {
    case comparison.FETCH: {
      const elIndex = state.companies.findIndex(el => el && el.ticker === action.payload.ticker);
      if (elIndex === -1) {
        state.companies[action.payload.choice] = {ticker: action.payload.ticker, name: 'Loading...'};
        state.isFetching = true;
      } else {
        action.payload = false;
      }
      return state;
    }

    case comparison.FETCH_SUCCESS: {
      const elIndex = state.companies.findIndex(el => el && el.ticker === action.payload.ticker);
      state.companies[elIndex] = action.payload;

      return {
        ...state,
        isFetching: false
      };
    }

     case comparison.FETCH_FAIL: {

      state.companies[action.payload.choice] = {ticker: action.payload.ticker, name: 'Load Error'};
      return {
        ...state,
        isFetching: false,
      };
    }

    case comparison.REMOVE_COMPANY: {
      
      state.companies.splice(action.payload, 1);
      return {
        ...state,
        isFetching: false,
      };
    }

    case comparison.REORDER_COMPANIES: {
      state.companies = reorderArray(state.companies, action.payload);
      return {
        ...state,
        isFetching: false,
      };
    }

    case comparison.SET_CHART: {
      
      state.chart = action.payload;
      return {
        ...state
      };
    }

    default: {
      return state;
    }
  }
}
export const getComparison = (state: State) => state;
export const getComparisonCompanies = (state: State) => state.companies;


// WEBPACK FOOTER //
// ./src/reducers/comparison.reducer.ts